@let showcases = projects();

<section class="centered-with-padding py-7">
  @if (showcases.length < 1 && data.fallbackSuggestions) {
    <div class="mb-10">{{ data.fallbackSuggestions }}</div>
  }
  <app-button-middle-office styleClass="pb-2.5" type="EDIT_REALISATION" />
  <div class="grid grid-cols-1 gap-x-5 gap-y-7 desk:grid-cols-3 desk:gap-y-6">
    @for (showcase of showcases; track $index) {
      <button
        (click)="openRealisationsClientsPopup($index)"
        class="group relative h-72 overflow-hidden rounded-3xl text-left">
        <app-image
          [hoverEffect]="true"
          [image]="showcase.images[0]"
          [isPriority]="!isImageInPreviousBlocks && $index < 3"
          [pregenerationSize]="{ width: 350, height: 288 }" />
        <div class="absolute inset-0 bg-gradient-to-b from-transparent to-black/50"></div>
        <div class="absolute inset-x-5 bottom-5 flex items-center justify-between gap-x-6">
          <span class="font-title text-[18px] font-normal leading-5 tracking-[-0.36px] text-white">{{
            showcase.name
          }}</span>
          <div>
            <app-svg [height]="14" [inline]="true" [width]="23" class="text-white" src="assets/icons/arrow-right.svg" />
          </div>
        </div>
      </button>
    }
  </div>
  @if (showcases.length < maxItems()) {
    <div class="mx-auto w-fit pt-7">
      <app-button (onButtonClick)="loadNextPage()" [label]="'GLOBAL.SEE_MORE' | translate" />
    </div>
  }
</section>
